
export const CHANNELS = {
  /** @param {number} branchId */
  kds: (branchId) => `private-kds.${branchId}`,

  /** Branch-wide POS channel — staff watching all tables. @param {number} branchId */
  posBranch: (branchId) => `private-pos.branch.${branchId}`,

  /** Single dining-session channel. @param {number} token  session token */
  posSession: (token) => `private-pos.session.${token}`,
};

export const KDS_EVENTS = {
  ORDER_CREATED:  'order.created',
  ORDER_STATE_UPDATED: 'order.state.updated',
  ITEM_CANCELLED: 'order.item.cancelled',
  ITEM_DELETED: 'order.item.deleted',
  ITEM_UPDATED: 'order.item.updated',
  // ล้างของค้างทั้งสาขาจากหลังบ้าน — ไม่ส่ง id ราย item (รอบเดียวกระทบได้หลักพัน) จอต้องดึงใหม่
  ITEMS_BULK_COMPLETED: 'order.items.bulk_completed',
};

/** Events on the per-session channel (private-pos.{token}). */
export const POS_EVENTS = {
  ORDER_STATE_UPDATED: 'order.state.updated',
  ITEM_UPDATED: 'order.item.updated',
};

/**
 * Events on the branch-wide channel (private-pos.{branchId}).
 * NOTE: event names must match the Laravel broadcastAs() in ../silver-spoon-api
 * — confirm before wiring up.
 */
export const POS_BRANCH_EVENTS = {
  REQUESTED: 'service.requested',
  BILL_REQUESTED: 'service.bill.requested',
  OPEN_SESSION: 'service.open',
  CLOSE_SESSION: 'service.close',
};
